<template>
    <div class="row card p-3 mx-0 bgc-sredone rounded">
        <div class="col text-center">
            <p class="c-error bold mb-0">
                Opa! Esse CNPJ já está cadastrado. 
            </p>
            <p class="c-error" v-if="!$store.state.user.userAdm">
                Entre em contato com o suporte da
                <a class="px-0" href="https://web.whatsapp.com/send?phone=+5511941739617&amp;text=Ol%C3%A1%2C+tudo+bem%3F+Quero+conhecer+as+solu%C3%A7%C3%B5es+da+CashForce." target="_blank">
                    <span :class="`c-${getPrimaryColor}four regular pointer`">{{ getWhiteLabel | capitalizeFirstLetter }}.</span>
                </a>
            </p>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
